module.exports = __webpack_public_path__ + "img/Hawaiian Poke-Ahi Tuna.c7b46d29.jpg";